export default __webpack_public_path__ + "static/media/UniversLTStd-XBlackEx.25d6026f.otf";